export { default as SectionAccordion } from './SectionAccordion';
